import React from 'react';

interface NavigationSidebarProps {
    isOpen: boolean;
    onClose: () => void;
    currentPage: 'help' | 'privacy-security' | 'security-policy' | 'community-guidelines' | 'terms-of-service' | 'about';
    onGoToMenu: () => void;
    onGoToHelp: () => void;
    onGoToPrivacySecurity: () => void;
    onGoToSecurityPolicy: () => void;
    onGoToCommunityGuidelines: () => void;
    onGoToTermsOfService: () => void;
    onGoToAbout: () => void;
}

const NavigationSidebar: React.FC<NavigationSidebarProps> = ({
    isOpen,
    onClose,
    currentPage,
    onGoToMenu,
    onGoToHelp,
    onGoToPrivacySecurity,
    onGoToSecurityPolicy,
    onGoToCommunityGuidelines,
    onGoToTermsOfService,
    onGoToAbout,
}) => {
    if (!isOpen) {
        return (
            <button
                onClick={() => onClose()}
                style={{
                    position: 'fixed',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(102, 126, 234, 0.9)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '0 8px 8px 0',
                    padding: '15px 8px',
                    cursor: 'pointer',
                    fontSize: '20px',
                    zIndex: 1000,
                    boxShadow: '2px 0 8px rgba(0, 0, 0, 0.2)',
                    transition: 'all 0.3s ease',
                }}
                title="メニューを開く"
            >
                ☰
            </button>
        );
    }

    const menuItems = [
        { id: 'menu', label: 'メニューに戻る', onClick: onGoToMenu, icon: '🏠', isSpecial: true },
        { id: 'help', label: 'ヘルプ', onClick: onGoToHelp, icon: '❓' },
        { id: 'privacy-security', label: 'プライバシーセキュリティ', onClick: onGoToPrivacySecurity, icon: '🔒' },
        { id: 'security-policy', label: '情報セキュリティ基本方針', onClick: onGoToSecurityPolicy, icon: '🛡️' },
        { id: 'community-guidelines', label: 'コミュニティガイドライン', onClick: onGoToCommunityGuidelines, icon: '👥' },
        { id: 'terms-of-service', label: '利用規約', onClick: onGoToTermsOfService, icon: '📜' },
        { id: 'about', label: '運営者について', onClick: onGoToAbout, icon: 'ℹ️' },
    ];

    return (
        <>
            {/* オーバーレイ */}
            <div
                onClick={onClose}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 999,
                    transition: 'opacity 0.3s ease',
                }}
            />
            {/* サイドバー */}
            <div
                style={{
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: '280px',
                    background: 'rgba(255, 255, 255, 0.98)',
                    boxShadow: '2px 0 10px rgba(0, 0, 0, 0.2)',
                    zIndex: 1000,
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'transform 0.3s ease',
                    overflow: 'hidden',
                }}
            >
                {/* 閉じるボタン */}
                <div
                    style={{
                        padding: '15px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    <button
                        onClick={onClose}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: '#666',
                            fontSize: '24px',
                            cursor: 'pointer',
                            padding: '5px',
                            width: '35px',
                            height: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '50%',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(0, 0, 0, 0.05)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                        }}
                    >
                        ×
                    </button>
                </div>

                {/* メニュー項目 */}
                <div
                    style={{
                        flex: 1,
                        overflow: 'auto',
                        padding: '10px 0',
                    }}
                >
                    {menuItems.map((item) => (
                        <button
                            key={item.id}
                            onClick={() => {
                                item.onClick();
                                onClose();
                            }}
                            style={{
                                width: '100%',
                                padding: '15px 20px',
                                background: item.isSpecial 
                                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                    : currentPage === item.id 
                                        ? 'rgba(102, 126, 234, 0.1)' 
                                        : 'transparent',
                                border: 'none',
                                borderLeft: !item.isSpecial && currentPage === item.id ? '4px solid #667eea' : '4px solid transparent',
                                color: item.isSpecial ? 'white' : currentPage === item.id ? '#667eea' : '#333',
                                fontSize: item.isSpecial ? '16px' : '15px',
                                fontWeight: item.isSpecial ? 'bold' : 'normal',
                                textAlign: 'left',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                                if (!item.isSpecial && currentPage !== item.id) {
                                    e.currentTarget.style.background = 'rgba(0, 0, 0, 0.05)';
                                } else if (item.isSpecial) {
                                    e.currentTarget.style.opacity = '0.9';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!item.isSpecial && currentPage !== item.id) {
                                    e.currentTarget.style.background = 'transparent';
                                } else if (item.isSpecial) {
                                    e.currentTarget.style.opacity = '1';
                                }
                            }}
                        >
                            <span style={{ fontSize: '20px' }}>{item.icon}</span>
                            <span>{item.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        </>
    );
};

export default NavigationSidebar;

